import { GetSettingsFn } from "../../../../rest/settings";
import { SettingsActions } from "../SettingsActions";
import { FlagActions } from "../../../flux/Flag/FlagActions";
import { ErrorActions } from "../../../flux/Error/ErrorActions";
import { Division } from "../../../../models";
import { LanguageOption } from "../../../../polyglot/languagePacks";
import { Command } from "../../../../Command";

// InitSettingsCommand is executed on initial render of the Settings UI component
export class InitSettingsCommand implements Command
{
    private readonly settingsActions = new SettingsActions();
    private readonly flagActions = new FlagActions();
    private readonly errorActions = new ErrorActions();

    constructor(
        private getSettings: GetSettingsFn,
        private getCurrentDivision: () => Division,
        private getLanguageOptions: () => LanguageOption[],
        private getCurrentLanguage: () => LanguageOption,
        private inProgressDispatchToken: string, private errorDispatchToken: string)
    {
    }
    
    execute = () => {
        const division = this.getCurrentDivision();
        this.settingsActions.setDivision(division);

        const languages = this.getLanguageOptions();
        this.settingsActions.setLanguageItems(languages);

        const curLanguage = this.getCurrentLanguage();
        this.settingsActions.setLanguage(curLanguage);
        
        this.flagActions.set(this.inProgressDispatchToken);
        this.getSettings(division.id)
            .then(res => this.settingsActions.setSettingsItems(res))
            .catch(err => this.errorActions.setError(err, this.errorDispatchToken))
            .then(() => this.flagActions.reset(this.inProgressDispatchToken)); // finaly
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Settings/commands/InitSettingsCommand.ts